import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "snackbar__message" }
const _hoisted_2 = {
  key: 2,
  class: "snackbar__description"
}

import { computed } from 'vue'
import CheckCircle from '@/assets/CheckCircle.svg'
import CrossCircle from '@/assets/CrossCircle.svg'
import { SnackbarState } from '@/store/application-store'

interface Props {
  state: SnackbarState
  header: string
  text?: string
}

interface Emits {
  (event: 'click', e: MouseEvent): void
}


export default /*#__PURE__*/_defineComponent({
  __name: 'Snackbar',
  props: {
    state: null,
    header: null,
    text: null
  },
  emits: ["click"],
  setup(__props: any, { emit: emits }: { emit: ({
  (event: 'click', e: MouseEvent): void
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  state: SnackbarState
  header: string
  text?: string
};



const barStateClass = computed(() => 'snackbar' + '--' + props.state )



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(['snackbar', _unref(barStateClass)]),
    onClick: _cache[0] || (_cache[0] = ($event: any) => (emits('click', $event)))
  }, [
    (__props.state === 'success')
      ? (_openBlock(), _createBlock(_unref(CheckCircle), {
          key: 0,
          class: "snackbar__icon"
        }))
      : (_openBlock(), _createBlock(_unref(CrossCircle), {
          key: 1,
          class: "snackbar__icon"
        })),
    _createElementVNode("span", _hoisted_1, _toDisplayString(__props.header), 1),
    (__props.text)
      ? (_openBlock(), _createElementBlock("p", _hoisted_2, _toDisplayString(__props.text), 1))
      : _createCommentVNode("", true)
  ], 2))
}
}

})